import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const HighlighterFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="highlighterFilled" ref={ref} {...props}>
    <path d="M22.06,2.66V12.84a.78.78,0,0,1-.23.54l-4.92,4.74a.74.74,0,0,1-.8.15,3.74,3.74,0,0,0-3.89,1.3.72.72,0,0,1-.53.23.75.75,0,0,1-.53-.22L7.7,16.13a.76.76,0,0,1,0-1A4,4,0,0,0,8.87,11,.77.77,0,0,1,9,10.16l8.21-8a.73.73,0,0,1,.52-.22h3.54A.75.75,0,0,1,22.06,2.66ZM1.54,22H8.8l.88-.81L6,17.53Z" />
  </Icon>
)) as IconWithRender;

HighlighterFilledIcon.displayName = 'HighlighterFilledIcon';
HighlighterFilledIcon.renderIcon = (props) => (
  <HighlighterFilledIcon {...props} />
);
export default HighlighterFilledIcon;
